var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Solid/check-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.666C14.4183 18.666 18 15.0843 18 10.666C18 6.24774 14.4183 2.66602 10 2.66602C5.58172 2.66602 2 6.24774 2 10.666C2 15.0843 5.58172 18.666 10 18.666ZM13.7071 9.37312C14.0976 8.9826 14.0976 8.34943 13.7071 7.95891C13.3166 7.56838 12.6834 7.56838 12.2929 7.95891L9 11.2518L7.70711 9.95891C7.31658 9.56838 6.68342 9.56838 6.29289 9.95891C5.90237 10.3494 5.90237 10.9826 6.29289 11.3731L8.29289 13.3731C8.68342 13.7636 9.31658 13.7636 9.70711 13.3731L13.7071 9.37312Z",
    fill: "#00760C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.393ff33e45e6d33f7fc033d652c45504.svg";
export { ForwardRef as ReactComponent };